import { createCatalogThunks, createCatalogSlice } from '@amzn/d2c-application-website-common';
import { RoadieService } from 'src/services/roadie';
import { awsRum } from 'src/rum';

const thunks = createCatalogThunks(
  (_stage: string, csrfToken?: string) => new RoadieService(csrfToken),
  {
    error: (message, context) => { awsRum?.recordEvent('CatalogError', { message, ...context }); },
    recordAPIError: (site, api, status) => { awsRum?.recordEvent('APIError', { site, api, status }); },
    recordAPIRequest: (site, api) => { awsRum?.recordEvent('APIRequest', { site, api }); },
  },
);

export const { hydrateCatalog } = thunks;
const catalogSlice = createCatalogSlice(thunks);
export const { replaceCatalogState } = catalogSlice.actions;
export default catalogSlice.reducer;

export {
  selectHydrateCatalogComplete,
  selectCatalog,
  selectFailed,
  selectCatalogError,
} from '@amzn/d2c-application-website-common';
